import i18n, { type InitOptions } from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import type { HttpBackendOptions } from "i18next-http-backend";
import { initReactI18next } from "react-i18next";
import translationPL from "../assets/locales/pl/translations.json";
import { isRelease } from "./utils";

export const defaultNS = "translations";
export const resources = {
	pl: { translations: translationPL },
} as const;

const i18nOptions: InitOptions<HttpBackendOptions> = {
	lng: "pl",
	ns: [defaultNS],
	debug: !isRelease,
	fallbackLng: "pl",
	interpolation: {
		escapeValue: false, // not needed for react as it escapes by default
	},
	resources: {
		pl: { translations: translationPL },
	},
};

void i18n
	.use(initReactI18next)
	.use(LanguageDetector)
	.init<HttpBackendOptions>(i18nOptions);
